"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var center = [23, 113];

var Path = function () {
    function Path(map) {
        _classCallCheck(this, Path);

        this.map = map;
        this.points = [];
        this.pathLayer = L.layerGroup();
        this.mapPoints = [];
        this.mapLines = [];
        this.mapTips = [];
        this.mapPointIndexMap = new WeakMap();
        this.changeHandler = null;
        this.pathLayer.addTo(this.map);
    }

    _createClass(Path, [{
        key: 'refreshTips',
        value: function refreshTips() {
            var _this = this;

            var distance = 0;
            this.mapTips.forEach(function (x, i) {
                x.setIcon(L.divIcon({
                    className: 'tip-2',
                    iconAnchor: [-20, 0],
                    html: '<div class="tip">' + (distance === 0 ? '起点' : (distance / 1000).toFixed(1) + '公里') + '</div>'
                }));
                x.setLatLng(_this.points[i]);
                if (i + 1 < _this.points.length) distance += _this.map.distance(_this.points[i], _this.points[i + 1]);
            });
            if (this.changeHandler) this.changeHandler(distance, this.points.length ? this.points[this.points.length - 1] : null);
        }
    }, {
        key: 'createMapPoint',
        value: function createMapPoint(pos) {
            var _this2 = this;

            var moved = false;
            return L.circleMarker(pos, {
                radius: 4,
                color: 'rgb(51, 136, 255)',
                fillColor: 'white',
                fillOpacity: 1,
                weight: 2,
                className: 'path-point'
            }).addTo(this.pathLayer).on('mousedown', function (e) {
                console.log('point down', e.originalEvent.target);
                moved = false;
                _this2.map.dragging.disable();
                var index = _this2.mapPointIndexMap.get(e.target);
                var handler = function handler(e) {
                    moved = true;
                    _this2.move(index, [e.latlng.lat, e.latlng.lng]);
                    _this2.refreshTips();
                };
                var handler2 = function handler2(e) {
                    console.log('point up', e.originalEvent.target);
                    _this2.map.off('mousemove', handler);
                    _this2.map.off('mouseup', handler2);
                    _this2.map.dragging.enable();
                };
                _this2.map.on('mousemove', handler).on('mouseup', handler2);
            }).on('click', function (e) {
                console.log('point click', e.originalEvent.target);
                if (moved) return;
                _this2.remove(_this2.mapPointIndexMap.get(e.target));
            });
        }
    }, {
        key: 'add',
        value: function add(point) {
            var prevPoint = this.points[this.points.length - 1];
            this.points.push(point);
            var mapPoint = this.createMapPoint(point);
            this.mapPointIndexMap.set(mapPoint, this.points.length - 1);
            this.mapPoints.push(mapPoint);
            this.mapTips.push(L.marker(point, {}).addTo(this.pathLayer).on('mousedown', function (e) {
                return console.log('tip down', e.originalEvent.target);
            }).on('click', function (e) {
                return console.log('tip click', e.originalEvent.target);
            }).on('mouseup', function (e) {
                return console.log('tip up', e.originalEvent.target);
            }));
            if (prevPoint != null) {
                this.mapLines.push(L.polyline([prevPoint, point], {
                    color: 'rgb(51, 136, 255, .5)'
                }).addTo(this.pathLayer).bringToBack());
            }
            this.refreshTips();
            return this;
        }
    }, {
        key: 'refreshMapPointIndexMap',
        value: function refreshMapPointIndexMap() {
            var _this3 = this;

            this.mapPoints.forEach(function (x, i) {
                return _this3.mapPointIndexMap.set(x, i);
            });
        }
    }, {
        key: 'remove',
        value: function remove(i) {
            var point = this.points.splice(i, 1)[0];
            if (point == null) return this;
            this.mapPoints.splice(i, 1)[0].remove();
            this.mapTips.splice(i, 1)[0].remove();
            if (i > 0) {
                if (i < this.points.length) this.mapLines[i].setLatLngs([this.points[i - 1], this.points[i]]);
                this.mapLines.splice(i - 1, 1)[0].remove();
            } else {
                if (i < this.points.length) this.mapLines.splice(i, 1)[0].remove();
            }
            this.refreshMapPointIndexMap();
            this.refreshTips();
            return this;
        }
    }, {
        key: 'move',
        value: function move(i, point) {
            this.points[i] = point;
            this.mapPoints[i].setLatLng(point);
            if (i > 0) {
                this.mapLines[i - 1].setLatLngs([this.points[i - 1], this.points[i]]);
            }
            if (i < this.points.length - 1) {
                this.mapLines[i].setLatLngs([this.points[i], this.points[i + 1]]);
            }
            return this;
        }
    }, {
        key: 'removeFromMap',
        value: function removeFromMap() {
            this.pathLayer.remove();
        }
    }, {
        key: 'setChangeHandler',
        value: function setChangeHandler(fn) {
            this.changeHandler = fn;
            return this;
        }
    }]);

    return Path;
}();

var PathMeasurement = function () {
    function PathMeasurement(map, destoryHook) {
        var _this4 = this;

        _classCallCheck(this, PathMeasurement);

        this.map = map;
        this.destoryHook = destoryHook;
        this.path = null;
        this.drawing = false;
        this.distance = 0;
        this.tipMarker = L.marker([91, 181], {
            icon: L.divIcon({
                html: '',
                className: 'my-div-icon'
            })
        }).on('click', function (e) {
            console.log('marker click', e.originalEvent.target);
            if (e.originalEvent.target.className === 'close-btn') {
                _this4.destory();
            } else {
                _this4.pause();
            }
        }).on('mousedown', function (e) {
            return console.log('marker mousedown', e.originalEvent.target, e.originalEvent);
        });
        this.tipIconProps = {
            iconSize: [0, 0],
            iconAnchor: [0, 0]
        };
        this.pointerPoint = L.circleMarker([91, 181], {
            radius: 4,
            color: 'rgb(51, 136, 255)',
            fillColor: 'white',
            fillOpacity: 1,
            weight: 2,
            className: 'path-point'
        });
        this.destroyed = false;
        this.map.on('mousemove', this.handleMove.bind(this)).on('click', this.handleClick.bind(this)).on('dblclick', this.handleDoubleClick.bind(this));
    }

    _createClass(PathMeasurement, [{
        key: 'start',
        value: function start() {
            var _this5 = this;

            this.map.doubleClickZoom.disable();
            if (this.path != null) {
                this.path.removeFromMap();
            }
            this.path = new Path(this.map).setChangeHandler(function (distance, lastPoint) {
                if (lastPoint == null) {
                    _this5.destory();
                    return;
                }
                _this5.updateTip(distance, lastPoint);
            });
            this.drawing = true;
            this.map.addLayer(this.tipMarker).addLayer(this.pointerPoint);
        }
    }, {
        key: 'destory',
        value: function destory() {
            this.pause();
            this.path.removeFromMap();
            this.tipMarker.remove();
            this.pointerPoint.remove();
            this.destoryHook();
            this.map.doubleClickZoom.enable();
            this.destroyed = true;
        }
    }, {
        key: 'pause',
        value: function pause() {
            this.drawing = false;
            this.updateTip();
            this.pointerPoint.remove();
        }
    }, {
        key: 'resume',
        value: function resume() {
            if (this.destroyed) {
                this.start();
                this.destroyed = false;
            } else {
                this.drawing = true;
                this.pointerPoint.addTo(this.map);
                this.updateTip();
            }
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            if (this.drawing) this.pause();else this.resume();
        }
    }, {
        key: 'handleDoubleClick',
        value: function handleDoubleClick(e) {
            if (this.drawing) {
                this.pause();
            }
        }
    }, {
        key: 'handleMove',
        value: function handleMove(e) {
            this.pointerPoint.setLatLng([e.latlng.lat, e.latlng.lng]);
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            if (this.drawing) {
                if (this.path != null) {
                    this.path.add([e.latlng.lat, e.latlng.lng]);
                    this.updateTip(undefined, e.latlng);
                }
            }
        }
    }, {
        key: 'updateTip',
        value: function updateTip() {
            var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.distance;
            var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            this.distance = distance;
            this.tipMarker.setIcon(L.divIcon(Object.assign(Object.assign({}, this.tipIconProps), {
                className: 'tip-marker',
                html: '<div class="tip">\u603B\u957F: <span class="distance">' + (distance / 1000).toFixed(1) + '</span> <span class="unit">\u516C\u91CC</span>' + (this.drawing ? '<br /><span class="message">点击地图绘点</span><br /><span class="message">点击本标签结束测量</span>' : '') + '<div class="close-btn">\xD7</div></div>'
            })));
            if (pos != null) this.tipMarker.setLatLng(pos);
        }
    }]);

    return PathMeasurement;
}();

exports.PathMeasurement = PathMeasurement;


//////////////////
// WEBPACK FOOTER
// ./js/util/ruler.js
// module id = 36
// module chunks = 0